import React from 'react';
import { Outlet } from 'react-router-dom';
import {connect} from 'react-redux';

import throttle from 'lodash/throttle';

import isLoggedIn, {logout} from '../../utils/auth';

import {HeaderContainer} from '../views/header/Header';
import RhinoAlert from './alert/RhinoAlert';
import MessageSentAlert from './alert/MessageSentAlert';

import * as authActionCreators from '../../actions/auth';
import * as commonActionCreators from '../../actions/common';
import * as messagesActionCreators from '../../actions/messages';
let allActionCreators = Object.assign({}, authActionCreators, commonActionCreators, messagesActionCreators);


class AppHeader extends React.Component {

	constructor() {
		super();

		this.state = {
      lastUpdate: Date.now(),
      countDown: 0,
      logoutLimit: 60*60*1000, // 5*60*1000,
      logoutIntervalId: null,

      screenHeight: 0,
      screenOrientation: null,
      keyboardOpen: false,

      lastScrollInc: 0,
    };

    if(isLoggedIn()) {
      document.getElementsByTagName("META")[2].content="width=device-width, height=device-height, viewport-fit=cover, initial-scale=1.0";
    }

    // Bind event listener method
    this.stayAwake = this.stayAwake.bind(this);
    this.checkLogout = this.checkLogout.bind(this);
    this.checkScroll = this.checkScroll.bind(this);

    this.scrollThrottle = throttle(this.getScrollPercentage, 1000, { 'leading': true, 'trailing': false });
	}

	componentWillMount() {
    window.addEventListener('mousemove', this.stayAwake, false);
    window.addEventListener('mousedown', this.stayAwake, false);
    window.addEventListener('keydown', this.stayAwake, false);
  }

  componentDidMount() {
  	let intId = setInterval(this.checkLogout, 1000);

    let scrollId = setInterval(this.checkScroll, 100);
  }

  componentWillUnmount() {
    window.removeEventListener('mousemove', this.stayAwake, false);
    window.removeEventListener('mousedown', this.stayAwake, false);
    window.removeEventListener('keydown', this.stayAwake, false);
  }

  getScrollPercentage() {
    if(this.appBody) {
      this.props.commonScrollTop(this.appBody.scrollTop);
    }
  }

  stayAwake() {
    if(Date.now() > this.state.lastUpdate + 1000) {
      this.setState({
        lastUpdate: Date.now()
      });
    }
  }

  checkScroll() {
    if(this.state.lastScrollInc != this.props.common.lastScrollInc) {
      this.appBody.scrollTop = this.props.common.lastScrollPos;
      this.setState({ lastScrollInc: this.props.common.lastScrollInc });
    }
  }

  checkLogout() {
  	if(isLoggedIn() && Date.now() > (this.state.lastUpdate + this.state.logoutLimit)) {
  		this.logoutUser();
  	}
  }

  logoutUser() {
    logout();
    this.props.authClear();
    this.setState({menuOpen: false});

    window.location.reload();
  }

	getHeaderHideStyles() {
    return window.location.pathname === '/' ? {padding: '0', minHeight: '100vh', top: '0'} : {};
  }


	render() {
		return <div className='AppHeader'>
			<HeaderContainer />
			<div className={isLoggedIn() ? 'appBody loggedIn' : 'appBody'} 
           style={this.getHeaderHideStyles()} 
           ref={(div) => { this.appBody = div; }}
           onScroll={this.scrollThrottle.bind(this)}>
				<Outlet />
			</div>
			<RhinoAlert 
        open={this.props.common.alertOpen} 
        config={this.props.common.alertConfig ? this.props.common.alertConfig : {}}
        alertText={this.props.common.alertText} 
        closeMethod={this.props.commonCloseAlert.bind(this)} />
      <MessageSentAlert open={this.props.messages.confirmAlertOpen} closeMethod={this.props.messagesHideConfirmation.bind(this)} alertText={this.props.messages.confirmAlertText} />
		</div>;
	}
}
export default AppHeader;

function mapStateToProps(state) {
  return {
    auth: state.auth,
    common: state.common,
    messages: state.messages,
  };
}

export const AppHeaderContainer = connect(
  mapStateToProps,
  allActionCreators
)(AppHeader);